import { useMemo, useSyncExternalStore } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { getStoredToken, subscribeSessionToken } from "../api/client";
import { useSession } from "../auth/sessionContext";
import { createSessionSupportClient } from "./reviewerApi";
import { SupportChatWidget } from "./SupportChatWidget";

export function PublicSupportLayout() {
  const location = useLocation();
  return <><Outlet /><SupportChatWidget key={location.key} /></>;
}

export function AuthenticatedSupportChat() {
  const session = useSession();
  const location = useLocation();
  const token = useSyncExternalStore(subscribeSessionToken, getStoredToken, () => null);
  const client = useMemo(() => token ? createSessionSupportClient(token) : null, [token]);
  if (!token || !client) return null;
  // Remounting destroys all draft text and aborts status, answer and feedback
  // requests before a new account, workspace, token or route can reuse them.
  const scope = JSON.stringify([
    token, session.user.id, session.user.tenant_id, session.tenant?.id,
    session.featureTenantId, location.key, location.pathname, location.search, location.hash,
  ]);
  return <SupportChatWidget key={scope} client={client} />;
}
